import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class ApiGenerealSearchResults extends API {
	getGenerealSearchResults(asunto, pagination, currentPage) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}?asunto=${asunto}&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}
export const apiGenerealSearchResults = new ApiGenerealSearchResults('/temas/predictivo');
